import { __awaiter, __generator } from "tslib";
import axios from "axios";
import { FetchError } from "configcat-common";
var HttpConfigFetcher = /** @class */ (function () {
    function HttpConfigFetcher() {
    }
    HttpConfigFetcher.prototype.fetchLogic = function (options, lastEtag) {
        return __awaiter(this, void 0, void 0, function () {
            var headers, axiosConfig, response, err_1, statusCode_1, reasonPhrase_1, _a, code, message, statusCode, reasonPhrase, eTag;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        headers = typeof window !== "undefined" || !lastEtag
                            // NOTE: It's intentional that we don't specify the If-None-Match header.
                            // The browser automatically handles it, adding it manually would cause an unnecessary CORS OPTIONS request.
                            ? {}
                            : { "If-None-Match": lastEtag };
                        axiosConfig = {
                            method: "get",
                            timeout: options.requestTimeoutMs,
                            url: options.getUrl(),
                            headers: headers,
                            responseType: "text",
                            transformResponse: function (data) { return data; }
                        };
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, axios(axiosConfig)];
                    case 2:
                        response = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _b.sent();
                        (response = err_1.response);
                        if (response) {
                            statusCode_1 = response.status, reasonPhrase_1 = response.statusText;
                            return [2 /*return*/, { statusCode: statusCode_1, reasonPhrase: reasonPhrase_1 }];
                        }
                        else if (err_1.request) {
                            _a = err_1, code = _a.code, message = _a.message;
                            switch (code) {
                                case "ERR_CANCELED":
                                    throw new FetchError("abort");
                                case "ECONNABORTED":
                                    // Axios ambiguously use ECONNABORTED instead of ETIMEDOUT, so we need this additional check to detect timeout
                                    // (see https://github.com/axios/axios/issues/1543#issuecomment-558166483)
                                    if (message.indexOf("timeout") >= 0) {
                                        throw new FetchError("timeout", options.requestTimeoutMs);
                                    }
                                    break;
                                default:
                                    break;
                            }
                            throw new FetchError("failure", err_1);
                        }
                        throw err_1;
                    case 4:
                        statusCode = response.status, reasonPhrase = response.statusText;
                        if (response.status === 200) {
                            eTag = response.headers.etag;
                            return [2 /*return*/, { statusCode: statusCode, reasonPhrase: reasonPhrase, eTag: eTag, body: response.data }];
                        }
                        return [2 /*return*/, { statusCode: statusCode, reasonPhrase: reasonPhrase }];
                }
            });
        });
    };
    return HttpConfigFetcher;
}());
export { HttpConfigFetcher };
